module.exports = __webpack_public_path__ + "static/img/mask@2x.fcb43e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter/mask@2x.png
// module id = qgZn
// module chunks = 44